import PropTypes from 'prop-types';
import HeroTemplate from '../heroTemplate/heroTemplate';
import styles from '../../styles/main.module.scss';
import Content404 from './content404/content404';
import Bg404 from './404.jpg';

export default function Custom404({ content404 = null }) {
  const data = {
    hero: {
      title: null,
      headline: '',
      theme: 'white',
      affectCreditScore: null,
      config: {
        gradientMask: null,
      },
      cta: null,
      heroDesc: null,
      heroWhiteCopyBg: '',
      image: {
        alt: '404',
        src: Bg404.src,
      },
      logos: [],
      prequal: '',
      socialProof: [],
      subHeroText: null,
      tiles: 'none',
    },
    content404: content404 ?? {},
  };

  return (
    <main className={styles.main}>
      <div className={styles.landingPage}>
        <div className={styles.components}>
          <HeroTemplate {...data.hero} />
          <div className={styles.container}>
            <div className={styles.section}>
              <Content404 {...data.content404} />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

Custom404.propTypes = {
  content404: PropTypes.shape({
    headline: PropTypes.string,
    subTitle: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    }),
    theme: PropTypes.string,
  }),
};
